import { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { SwiperSlide, Swiper } from 'swiper/react';
import { FreeMode, Navigation, Thumbs, Pagination } from 'swiper/modules';
import { RootState } from '../../store';
import { IPhotos } from '../../pages/CatalogDetail/interface';

import Icon from '../Icon';

import bemClassName from '../../utils/bem';

import './index.scss';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const carouselDetail = bemClassName('carousel-detail');

const CarouselDetail = ({
  data,
  onClick,
  modalOpen,
}: {
  data: IPhotos | undefined;
  onClick?: () => void;
  modalOpen?: boolean;
}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>();

  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);

  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);

  return windowWidth < 1024 ? (
    <Swiper
      className={carouselDetail({ mobile_modal: modalOpen })}
      spaceBetween={0}
      slidesPerView={1}
      modules={[Pagination]}
      pagination={{ clickable: true }}
      loop>
      {data &&
        data['298x298'] &&
        data['298x298'].map((item, id) => {
          return (
            <SwiperSlide onClick={onClick} key={id}>
              {modalOpen ? (
                <picture className={carouselDetail('picture')}>
                  <source
                    media="(max-width: 600px)"
                    type="image/webp"
                    srcSet={`${data['600x348'][id]}, ${data['1200x696'][id]} 2x, ${data['1800x1044'][id]} 3x`}
                  />
                  <source
                    type="image/webp"
                    srcSet={`${data['600x348'][id]}, ${data['1200x696'][id]} 2x, ${data['1800x1044'][id]} 3x`}
                  />
                  <img
                    className={carouselDetail('image')}
                    src={`${data['600x348'][id]}`}
                    srcSet={`${data['1200x696'][id]} 2x, ${data['1800x1044'][id]} 3x`}
                    alt="Фото квартиры"
                  />
                </picture>
              ) : (
                <picture className={carouselDetail('picture')}>
                  <source
                    media="(max-width: 600px)"
                    type="image/webp"
                    srcSet={`${data['580x312'][id]}, ${data['1160x624'][id]} 2x, ${data['1740x936'][id]} 3x`}
                  />
                  <source
                    type="image/webp"
                    srcSet={`${data['580x312'][id]}, ${data['1160x624'][id]} 2x, ${data['1740x936'][id]} 3x`}
                  />
                  <img
                    className={carouselDetail('image')}
                    onClick={onClick}
                    src={`${data['580x312'][id]}`}
                    srcSet={`${data['1160x624'][id]} 2x, ${data['1740x936'][id]} 3x`}
                    alt="Фото квартиры"
                  />
                </picture>
              )}
            </SwiperSlide>
          );
        })}
    </Swiper>
  ) : (
    <div className={carouselDetail('carousel-desktop-wrap', { modal: modalOpen })}>
      <Swiper
        className={carouselDetail({ desktop: true })}
        loop
        spaceBetween={0}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
        modules={[FreeMode, Navigation, Thumbs, Pagination]}
        pagination={{ clickable: true }}>
        {data &&
          data['298x298'] &&
          data['298x298'].map((item, id) => {
            return (
              <SwiperSlide onClick={onClick} key={id}>
                {modalOpen ? (
                  <picture className={carouselDetail('picture')}>
                    <source
                      type="image/webp"
                      srcSet={`${data['1595x925'][id]}, ${data['3190x1850'][id]} 2x, ${data['4785x2775'][id]} 3x`}
                    />
                    <img
                      className={carouselDetail('image', {
                        image_modal: modalOpen,
                      })}
                      src={`${data['1595x925'][id]}`}
                      srcSet={`${data['3190x1850'][id]} 2x, ${data['4785x2775'][id]} 3x`}
                      alt="Фото квартиры"
                    />
                  </picture>
                ) : (
                  <picture className={carouselDetail('picture')}>
                    <source
                      type="image/webp"
                      srcSet={`${data['836x450'][id]}, ${data['1672x900'][id]} 2x, ${data['2508x1350'][id]} 3x`}
                    />
                    <img
                      className={carouselDetail('image', {
                        image_modal: modalOpen,
                      })}
                      src={`${data['836x450'][id]}`}
                      srcSet={`${data['1672x900'][id]} 2x, ${data['2508x1350'][id]} 3x`}
                      alt="Фото квартиры"
                    />
                  </picture>
                )}
              </SwiperSlide>
            );
          })}
        <div
          className={carouselDetail('carousel-navigation', { prev: true })}
          ref={navigationPrevRef}>
          <Icon
            iconName="arrow"
            externalClassName={carouselDetail('carousel-navigation-icon', {
              prev: true,
            })}
          />
        </div>
        <div
          className={carouselDetail('carousel-navigation', { next: true })}
          ref={navigationNextRef}>
          <Icon
            iconName="arrow"
            externalClassName={carouselDetail('carousel-navigation-icon', {
              next: true,
            })}
          />
        </div>
      </Swiper>
      <Swiper
        className={carouselDetail({ thumbs: true })}
        onSwiper={setThumbsSwiper}
        loop
        spaceBetween={15}
        slidesPerView="auto"
        freeMode
        watchSlidesProgress
        modules={[FreeMode, Navigation, Thumbs]}
        direction="vertical">
        {data &&
          data['298x298'] &&
          data['298x298'].map((item, id) => {
            return (
              <SwiperSlide key={id}>
                <picture className={carouselDetail('picture')}>
                  <img
                    className={carouselDetail('image', {
                      image_modall: modalOpen,
                    })}
                    src={`${data['150x100'][id]}`}
                    srcSet={`${data['298x298'][id]} 2x, ${data['525x282'][id]} 3x`}
                    alt="Фото квартиры"
                  />
                </picture>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
};

export default CarouselDetail;
